import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

// TODO - rename this to REGULATORY_FRAMEWORK_AND_GOVERNING_BODY
export const LICENSE_OR_REGULATORY_FRAMEWORK: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.regulatoryFramework,
    label: "Regulatory Framework",
    tooltip: CatalogReferenceDataSlugs.regulatory_framework,
    type: ColumnTypes.string,
    sortsOn: AssetColumns.regulatoryFramework,
    width: 675,
    loginRequired: true,
    render: (item) => {
        if (item.isAsset) {
            if (!item.governing_body && !item.regulatory_framework) {
                return <Emdash />;
            }

            return (
                <div className="flex flex-col">
                    <p className="text-foreground dg-overflow">
                        {item.regulatory_framework}
                    </p>
                    <p className="font-light text-xs text-muted-foreground dg-overflow">
                        {item.governing_body}
                    </p>
                </div>
            );
        }

        return <Emdash />;
    },
};

export const LICENSE_OR_REGULATORY_FRAMEWORK_INLINE: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    ...LICENSE_OR_REGULATORY_FRAMEWORK,
    render: (item) => {
        if (item.isAsset) {
            if (!item.governing_body && !item.regulatory_framework) {
                return <Emdash />;
            }

            return (
                <div className="flex flex-col items-end">
                    <p className="text-foreground">
                        {item.regulatory_framework}
                    </p>
                    <p className="font-light text-xs text-muted-foreground">
                        {item.governing_body}
                    </p>
                </div>
            );
        }

        return <Emdash />;
    },
};

// // // //

export const REGULATORY_FRAMEWORK_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.regulatoryFramework,
    sortsOn: AssetColumns.regulatoryFramework,
    tooltip: CatalogReferenceDataSlugs.regulatory_framework,
    label: "Regulatory Framework",
    type: ColumnTypes.string,
    width: 410,
    loginRequired: true,
    cellValue: (item) => {
        if (item.isAsset) {
            return item.regulatory_framework;
        }

        return null;
    },
};
